export var dayGroup = {
    dateRole: 'day',
    name: 'Day',
    mask: 'DD',
    pattern: '(3[01]|[12][0-9]|0[1-9])',
    title: '2-digit day',
    autoComplete: 'off',
};
export var monthGroup = {
    dateRole: 'month',
    name: 'Month',
    mask: 'MM',
    pattern: '(1[012]|0[1-9])',
    title: '2-digit month',
    autoComplete: 'off',
};
export var yearGroup = {
    dateRole: 'year',
    name: 'Year',
    mask: 'YYYY',
    pattern: '((?:19|20)[0-9][0-9])',
    title: '4-digit year between 1900 and 2099',
    autoComplete: 'off',
};
export var DD_MM_YYYY = function (groups) { return [
    groups.day,
    groups.month,
    groups.year,
]; };
export var MM_DD_YYYY = function (groups) { return [
    groups.month,
    groups.day,
    groups.year,
]; };
export var YYYY_MM_DD = function (groups) { return [
    groups.year,
    groups.month,
    groups.day,
]; };
export var stringsToDate = function (strings, groups) {
    if (strings === undefined)
        return undefined;
    if (strings === null)
        return null;
    if (strings.some(function (i) { return i === undefined; }))
        return undefined;
    if (strings.some(function (i) { return i === null; }))
        return null;
    if (strings.some(function (i) { return i === ''; }))
        return null;
    var year = Number(strings[groups.findIndex(function (i) { return i.dateRole === 'year'; })]);
    var month = Number(strings[groups.findIndex(function (i) { return i.dateRole === 'month'; })]) - 1;
    var day = Number(strings[groups.findIndex(function (i) { return i.dateRole === 'day'; })]);
    return new Date(year, month, day);
};
var getGroup = function (dateRole, groups) { return groups.find(function (i) { return i.dateRole === dateRole; }); };
export var dateToStrings = function (date, groups) {
    var _a, _b, _c;
    if (!date)
        return ['', '', ''];
    var currentDayGroup = (_a = getGroup('day', groups)) !== null && _a !== void 0 ? _a : dayGroup;
    var currentMonthGroup = (_b = getGroup('month', groups)) !== null && _b !== void 0 ? _b : monthGroup;
    var currentYearGroup = (_c = getGroup('year', groups)) !== null && _c !== void 0 ? _c : yearGroup;
    var strings = {
        day: date.getDate().toLocaleString(undefined, {
            minimumIntegerDigits: currentDayGroup.mask.length,
            useGrouping: false,
        }),
        month: (date.getMonth() + 1).toLocaleString(undefined, {
            minimumIntegerDigits: currentMonthGroup.mask.length,
            useGrouping: false,
        }),
        year: date.getFullYear().toLocaleString(undefined, {
            minimumIntegerDigits: currentYearGroup.mask.length,
            useGrouping: false,
        }),
    };
    return groups.map(function (i) { return strings[i.dateRole]; });
};
export var isValidIntegerOrEmpty = function (str) { return str.match(/^\d*$/); };
export var areDateStringsValid = function (dateStrings, groups) {
    if (!dateStrings.every(isValidIntegerOrEmpty))
        return false;
    var isStringTooShort = function (group, index) {
        return dateStrings[index].length < group.mask.length;
    };
    if (groups.some(isStringTooShort))
        return false;
    return true;
};
//# sourceMappingURL=InputGroupsWithDatePicker.utils.js.map